
import { defineComponent, SetupContext } from "vue";


export default defineComponent({
  name: "TopicListItem",
  props: {
    /**
     * レシピ画像
     */
    recipeImageUrl: {
      type: String
    },
    /**
     * レシピ名
     */
    recipeLabel: {
      type: String,
      required: true
    }
  },
  setup(_, context: SetupContext) {
    /**
     * ボタンが押されたことを通知する
     */
    const onClick = () => context.emit("on-click");
    /**
     * レシピサーバから取得したレシピ名称に改行タグが含まれる可能性があるため取り除いて表示する
     *
     * @param {string} label - レシピ名称
     * @returns {string} レシピ名称
     */
    const removeBr = (label: string) => label.replace("<br/>", "");
    return {
      onClick,
      removeBr
    };
  }
});
